var _regeneratorRuntime = require("/Users/rishavanand/Projects/Exponents/virtooally-event/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _asyncToGenerator = require("/Users/rishavanand/Projects/Exponents/virtooally-event/node_modules/@babel/runtime/helpers/asyncToGenerator");

var querystring = require('querystring');

var Cache = require('./cache');

var utils = require('./utils'); // A shared cache to keep track of html5player.js tokens.


exports.cache = new Cache();
/**
 * Extract signature deciphering tokens from html5player file.
 *
 * @param {string} html5playerfile
 * @param {Object} options
 * @returns {Promise<Array.<string>>}
 */

exports.getTokens = function (html5playerfile, options) {
  return exports.cache.getOrSet(html5playerfile, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var body, tokens;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return utils.exposedMiniget(html5playerfile, options).text();

          case 2:
            body = _context.sent;
            tokens = exports.extractActions(body);

            if (!(!tokens || !tokens.length)) {
              _context.next = 6;
              break;
            }

            throw Error('Could not extract signature deciphering actions');

          case 6:
            exports.cache.set(html5playerfile, tokens);
            return _context.abrupt("return", tokens);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })));
};
/**
 * Decipher a signature based on action tokens.
 *
 * @param {Array.<string>} tokens
 * @param {string} sig
 * @returns {string}
 */


exports.decipher = function (tokens, sig) {
  sig = sig.split('');

  for (var i = 0, len = tokens.length; i < len; i++) {
    var token = tokens[i],
        pos = void 0;

    switch (token[0]) {
      case 'r':
        sig = sig.reverse();
        break;

      case 'w':
        pos = ~~token.slice(1);
        sig = swapHeadAndPosition(sig, pos);
        break;

      case 's':
        pos = ~~token.slice(1);
        sig = sig.slice(pos);
        break;

      case 'p':
        pos = ~~token.slice(1);
        sig.splice(0, pos);
        break;
    }
  }

  return sig.join('');
};
/**
 * Swaps the first element of an array with one of given position.
 *
 * @param {Array.<Object>} arr
 * @param {number} position
 * @returns {Array.<Object>}
 */


var swapHeadAndPosition = function swapHeadAndPosition(arr, position) {
  var first = arr[0];
  arr[0] = arr[position % arr.length];
  arr[position] = first;
  return arr;
};

var jsVarStr = '[a-zA-Z_\\$][a-zA-Z_0-9]*';
var jsSingleQuoteStr = "'[^'\\\\]*(:?\\\\[\\s\\S][^'\\\\]*)*'";
var jsDoubleQuoteStr = "\"[^\"\\\\]*(:?\\\\[\\s\\S][^\"\\\\]*)*\"";
var jsQuoteStr = "(?:".concat(jsSingleQuoteStr, "|").concat(jsDoubleQuoteStr, ")");
var jsKeyStr = "(?:".concat(jsVarStr, "|").concat(jsQuoteStr, ")");
var jsPropStr = "(?:\\.".concat(jsVarStr, "|\\[").concat(jsQuoteStr, "\\])");
var jsEmptyStr = "(?:''|\"\")";
var reverseStr = ':function\\(a\\)\\{' + '(?:return )?a\\.reverse\\(\\)' + '\\}';
var sliceStr = ':function\\(a,b\\)\\{' + 'return a\\.slice\\(b\\)' + '\\}';
var spliceStr = ':function\\(a,b\\)\\{' + 'a\\.splice\\(0,b\\)' + '\\}';
var swapStr = ':function\\(a,b\\)\\{' + 'var c=a\\[0\\];a\\[0\\]=a\\[b(?:%a\\.length)?\\];a\\[b(?:%a\\.length)?\\]=c(?:;return a)?' + '\\}';
var actionsObjRegexp = new RegExp("var (".concat(jsVarStr, ")=\\{((?:(?:").concat(jsKeyStr).concat(reverseStr, "|").concat(jsKeyStr).concat(sliceStr, "|").concat(jsKeyStr).concat(spliceStr, "|").concat(jsKeyStr).concat(swapStr, "),?\\r?\\n?)+)\\};"));
var actionsFuncRegexp = new RegExp("".concat("function(?: ".concat(jsVarStr, ")?\\(a\\)\\{") + "a=a\\.split\\(".concat(jsEmptyStr, "\\);\\s*") + "((?:(?:a=)?".concat(jsVarStr)).concat(jsPropStr, "\\(a,\\d+\\);)+)") + "return a\\.join\\(".concat(jsEmptyStr, "\\)") + "\\}");
var reverseRegexp = new RegExp("(?:^|,)(".concat(jsKeyStr, ")").concat(reverseStr), 'm');
var sliceRegexp = new RegExp("(?:^|,)(".concat(jsKeyStr, ")").concat(sliceStr), 'm');
var spliceRegexp = new RegExp("(?:^|,)(".concat(jsKeyStr, ")").concat(spliceStr), 'm');
var swapRegexp = new RegExp("(?:^|,)(".concat(jsKeyStr, ")").concat(swapStr), 'm');
/**
 * Extracts the actions that should be taken to decipher a signature.
 *
 * This searches for a function that performs string manipulations on
 * the signature. We already know what the 3 possible changes to a signature
 * are in order to decipher it. There is
 *
 * * Reversing the string.
 * * Removing a number of characters from the beginning.
 * * Swapping the first character with another position.
 *
 * Note, `Array#slice()` used to be used instead of `Array#splice()`,
 * it's kept in case we encounter any older html5player files.
 *
 * After retrieving the function that does this, we can see what actions
 * it takes on a signature.
 *
 * @param {string} body
 * @returns {Array.<string>}
 */

exports.extractActions = function (body) {
  var objResult = actionsObjRegexp.exec(body);
  var funcResult = actionsFuncRegexp.exec(body);

  if (!objResult || !funcResult) {
    return null;
  }

  var obj = objResult[1].replace(/\$/g, '\\$');
  var objBody = objResult[2].replace(/\$/g, '\\$');
  var funcBody = funcResult[1].replace(/\$/g, '\\$');
  var result = reverseRegexp.exec(objBody);
  var reverseKey = result && result[1].replace(/\$/g, '\\$').replace(/\$|^'|^"|'$|"$/g, '');
  result = sliceRegexp.exec(objBody);
  var sliceKey = result && result[1].replace(/\$/g, '\\$').replace(/\$|^'|^"|'$|"$/g, '');
  result = spliceRegexp.exec(objBody);
  var spliceKey = result && result[1].replace(/\$/g, '\\$').replace(/\$|^'|^"|'$|"$/g, '');
  result = swapRegexp.exec(objBody);
  var swapKey = result && result[1].replace(/\$/g, '\\$').replace(/\$|^'|^"|'$|"$/g, '');
  var keys = "(".concat([reverseKey, sliceKey, spliceKey, swapKey].join('|'), ")");
  var myreg = "(?:a=)?".concat(obj, "(?:\\.").concat(keys, "|\\['").concat(keys, "'\\]|\\[\"").concat(keys, "\"\\])") + "\\(a,(\\d+)\\)";
  var tokenizeRegexp = new RegExp(myreg, 'g');
  var tokens = [];

  while ((result = tokenizeRegexp.exec(funcBody)) !== null) {
    var key = result[1] || result[2] || result[3];

    switch (key) {
      case swapKey:
        tokens.push("w".concat(result[4]));
        break;

      case reverseKey:
        tokens.push('r');
        break;

      case sliceKey:
        tokens.push("s".concat(result[4]));
        break;

      case spliceKey:
        tokens.push("p".concat(result[4]));
        break;
    }
  }

  return tokens;
};
/**
 * @param {Object} format
 * @param {string} sig
 */


exports.setDownloadURL = function (format, sig) {
  var decodedUrl;

  if (format.url) {
    decodedUrl = format.url;
  } else {
    return;
  }

  try {
    decodedUrl = decodeURIComponent(decodedUrl);
  } catch (err) {
    return;
  } // Make some adjustments to the final url.


  var parsedUrl = new URL(decodedUrl); // This is needed for a speedier download.
  // See https://github.com/fent/node-ytdl-core/issues/127

  parsedUrl.searchParams.set('ratebypass', 'yes');

  if (sig) {
    // When YouTube provides a `sp` parameter the signature `sig` must go
    // into the parameter it specifies.
    // See https://github.com/fent/node-ytdl-core/issues/417
    parsedUrl.searchParams.set(format.sp || 'signature', sig);
  }

  format.url = parsedUrl.toString();
};
/**
 * Applies `sig.decipher()` to all format URL's.
 *
 * @param {Array.<Object>} formats
 * @param {string} html5player
 * @param {Object} options
 */


exports.decipherFormats = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(formats, html5player, options) {
    var decipheredFormats, tokens;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            decipheredFormats = {};
            _context2.next = 3;
            return exports.getTokens(html5player, options);

          case 3:
            tokens = _context2.sent;
            formats.forEach(function (format) {
              var cipher = format.signatureCipher || format.cipher;

              if (cipher) {
                Object.assign(format, querystring.parse(cipher));
                delete format.signatureCipher;
                delete format.cipher;
              }

              var sig = tokens && format.s ? exports.decipher(tokens, format.s) : null;
              exports.setDownloadURL(format, sig);
              decipheredFormats[format.url] = format;
            });
            return _context2.abrupt("return", decipheredFormats);

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function (_x, _x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();